import * as React from 'react';
import { cn } from '../../helpers';

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  isLoading?: boolean;
  validationState?: 'success' | 'error' | 'none';
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      label,
      error,
      id,
      className,
      validationState,
      value = '',
      onChange,
      isLoading,
      ...props
    },
    ref,
  ) => {
    return (
      <div>
        <div className="relative w-full">
          <textarea
            ref={ref}
            id={id}
            value={value}
            onChange={onChange}
            className={cn(
              'peer h-32 block w-full px-3 pt-6 pb-1 text-bas rounded-xl focus:border focus:border-primary focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
              error
                ? 'border-red-500 focus-visible:ring-red-500'
                : 'focus-visible:ring-primary',
              value ? 'border border-primary' : '',
              validationState === 'success'
                ? '!border-green-500 !focus-visible:ring-green-500'
                : '',
              validationState === 'error'
                ? 'border-red-500 focus-visible:ring-red-500'
                : '',
              'bg-neutral-98 hover:bg-blue-95',
              className,
            )}
            {...props}
          />

          <label
            htmlFor={id}
            className={cn(
              'absolute z-10 line-clamp-1 left-3 pb-3 pointer-events-none top-1/4 -translate-y-1/2 text-base text-neutral-40 transition-all duration-300 transform origin-left scale-100 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:!top-1 peer-focus:translate-y-0 peer-focus:scale-75',
              value ? '!top-1 translate-y-0 !scale-75' : '',
            )}
          >
            {label}
          </label>
        </div>

        {error && (
          <p className="mt-1 ml-4 text-xs text-left text-red-00">{error}</p>
        )}
      </div>
    );
  },
);

TextArea.displayName = 'TextArea';

export { TextArea };
